
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerEditor()
    export class IcStockTransferEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, IcStockReturnOutRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return IcStockTransferRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
